import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { archiveConstants } from "./contstants/archive.contstants";
import { authHeader } from "../../helpers/authHeader";
import { handleResponse } from "../../helpers/handleresponse";
import { securityHelper } from "../../helpers/securityHelper";
import { cmsActions } from "../../store/actions/cms/cms.action";
import FileStorage from "./FileStorage";

const defaultState = {
  files: [],
  isOpen: false,
  filtered: null,
  uploadingInfo: null,
  selectedFile: null,
  unsplashFile: null,
  isUploading: false,
  storageUsage: 0,
  isCompleted: false,
  showLaunchBtn: true,
  fontEnabled: false,
  display: archiveConstants.IMAGE,
  useCropper: false,
  filterType: archiveConstants.IMAGE_TYPES,
};

function FileStorageWrapper(props) {
  const [state, setState] = useState(defaultState);
  const stateRef = useRef();
  stateRef.current = state;
  const {
    fontEnabled,
    onUseSelected,
    showLaunchBtn,
    isOpen,
    toggle,
    dispatch,
    cms,
    eventId,
    initialDisplay
  } = props;

  useEffect(() => {
    download();
    const newState = {
      ...stateRef.current,
      isOpen,
      showLaunchBtn,
      fontEnabled,
      display: initialDisplay ? initialDisplay : archiveConstants.IMAGE,
      filterType: initialDisplay ? archiveConstants[initialDisplay + "_TYPES"] : archiveConstants.IMAGE_TYPES,
    };
    setState(newState);
  }, []);
  const onSelect = (file, unsplash = false) =>
    setState({
      ...stateRef.current,
      selectedFile: !unsplash ? file : null,
      unsplashFile: unsplash ? file : null,
    });
  const filter = (str) => {
    if (!str) setState({ ...stateRef.current, filtered: [] });
    const { files } = stateRef.current;
    const filteredFiles = [
      ...files.filter((f, i) => {
        return f.name.includes(str);
      }),
    ];
    setState({
      ...stateRef.current,
      filtered: filteredFiles,
    });
  };

  const download = (fileType, all = false) => {
    const requestOptions = {
      method: "GET",
      headers: authHeader({}),
    };
    fetch(
      `./api/files/` + window.location.search + `?eventId=${eventId}`,
      requestOptions
    ).then((response) =>
      response.text().then((text) => {
        try {
          const storageSummary = JSON.parse(text);
          storageSummary.files &&
            storageSummary.files.map((f, i) => {
              return Object.assign(
                {},
                { ...f, key: securityHelper.createGuid() }
              );
            });
          if (storageSummary !== null && storageSummary !== undefined) {
            setState({
              ...stateRef.current,
              files: storageSummary.files,
              storageUsage: storageSummary.eventMemoryUsage,
            });
          }
        } catch (error) {
          console.error("DOWNLOAD_ERROR", error);
        }
      })
    );
  };
  const toggleParent = () => {
    setState({ ...stateRef.current, isOpen: false });
    if (toggle && typeof toggle === "function") toggle();
  };
  const navigate = (display, filterType) =>
    setState({
      ...stateRef.current,
      display,
      filterType,
      unsplashFile: null,
      selectedFile: null,
    });

  const onSelectFile = () => {
    const { selectedFile } = stateRef.current;
    if (!selectedFile) return;
    if (onUseSelected && typeof onUseSelected === "function") {
      if (selectedFile.type.includes("font/")) {
        let fontName = selectedFile.name.substring(
          selectedFile.name.lastIndexOf("/") + 1,
          selectedFile.name.indexOf(".")
        );
        onUseSelected(fontName);
        return;
      }
      onUseSelected(selectedFile.url, selectedFile.srcset);
      toggle();
    }
  };

  const onUnsplashDownload = (unsplashFile) => {
    const fileInfo = {
      name: "unsplash_image_" + securityHelper.createGuid(),
      size: 0,
      type: "image/jpeg",
      file: unsplashFile.urls.raw,
    };

    const requestOptions = {
      method: "POST",
      headers: authHeader({ "Content-Type": "application/json" }),
    };
    setState({
      ...stateRef.current,
      uploadingInfo: fileInfo,
      isUploading: true,
      display: archiveConstants.IMAGE,
      filterType: archiveConstants.IMAGE_TYPES,
    });

    let queryStr = "";
    if (window.location.search) {
      queryStr =
        window.location.search +
        `&eventId=` +
        eventId +
        "&url=" +
        encodeURIComponent(unsplashFile.urls.raw);
    } else {
      queryStr =
        "?url=" +
        encodeURIComponent(unsplashFile.urls.raw) +
        `&eventId=` +
        eventId;
    }

    const { storageUsage, files } = stateRef.current;

    fetch(`./api/files/unsplash` + queryStr, requestOptions)
      .then(handleResponse)
      .then((file) => {
        setState({
          ...stateRef.current,
          isCompleted: true,
          unsplashFile: null,
          selectedFile: { ...file },
          isUploading: false,
          display: archiveConstants.IMAGE,
          filterType: archiveConstants.IMAGE_TYPES,
          uploadingInfo: null,
          storageUsage: storageUsage + file.size,
          files: file ? [Object.assign({}, { ...file }), ...files] : [...files],
        });
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  const onDeleteFile = () => {
    const { selectedFile } = stateRef.current;
    let filePath = selectedFile.name;
    filePath = filePath.substring(filePath.lastIndexOf("/") + 1);
    let isCropped = selectedFile.isCropped ?? false;

    const requestOptions = {
      method: "DELETE",
      headers: authHeader({ "Content-Type": "application/json" }),
    };

    fetch(`./api/files/${filePath}/?isCropped=${isCropped}` + window.location.search, requestOptions)
      .then(handleResponse)
      .then((_) => {
        const files = Array.from(stateRef.current.files);
        const indexToRemove = files.indexOf(
          files.find((f) => {
            return f.id === selectedFile.id;
          })
        );
        files.splice(indexToRemove, 1);
        if (selectedFile.type.includes("font/")) {
          let fontName = selectedFile.name.substring(
            selectedFile.name.lastIndexOf("/") + 1,
            selectedFile.name.indexOf(".")
          );
          dispatch(cmsActions.removeFont(fontName));
        }
        setState({ ...stateRef.current, selectedFile: null, files });
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  const onUploadCropped = (img) => {
    const { storageUsage, files } = stateRef.current;
    let size = new Buffer(img, "base64").length / 1000;
    const uploadingInfo = {
      name: "_cropped_" + securityHelper.createGuid(),
      size: size,
      type: "image/jpeg",
      file: img,
    };
    const requestOptions = {
      method: "POST",
      headers: authHeader({ "Content-Type": "application/json" }),
      body: JSON.stringify(uploadingInfo),
    };
    setState({ ...stateRef.current, uploadingInfo, isUploading: true });

    fetch(`./api/files/` + window.location.search, requestOptions)
      .then(handleResponse)
      .then((file) => {
        this.setState(
          {
            storageUsage: storageUsage + file.size,
            selectedFile: Object.assign({}, { ...file }),
            files: file ? [...files, Object.assign({}, { ...file })] : {},
          },
          () => {
            setTimeout(() => {
              setState({
                isUploading: false,
                uploadingInfo: null,
                useCropper: false,
              });
            }, 2500);
          }
        );
      })
      .catch((err) => {
        console.error(err.message);
      });
  };
  const onUpload = (e) => {
    const file = e.target.files[0];
    let reader = new FileReader();
    const { files, selectedFile, storageUsage, fontEnabled } = stateRef.current;
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (reader.result) {
        const fileInfo = {
          name: file.name,
          size: file.size,
          type: file.type,
          file: reader.result,
        };
        const requestOptions = {
          method: "POST",
          headers: authHeader({ "Content-Type": "application/json" }),
          body: JSON.stringify(fileInfo),
        };
        setState({ ...stateRef.current, uploadingInfo: fileInfo, isUploading: true });
        fetch(
          `./api/files/?`/*  + window.location.search + */ + `eventId=${eventId}`,
          requestOptions
        )
          .then(handleResponse)
          .then((file) => {
            setState({
              ...stateRef.current,
              storageUsage: storageUsage + file.size,
              selectedFile: Object.assign({}, { ...file }),
              isUploading: false,
              uploadingInfo: null,
              files: file
                ? [Object.assign({}, { ...file }), ...files]
                : [...files],
            });
            if (file.type.includes("font/")) {
              if (fontEnabled) {
                let fontName = file.name.substring(
                  file.name.lastIndexOf("/") + 1,
                  file.name.indexOf(".")
                );

                props.onFontUpload(fontName, file.url);
              }
              navigate(archiveConstants.FONT, archiveConstants.FONT_TYPES);
            }
          })
          .catch((err) => {
            console.error(err.message);
          });
      }
    };
  };
  const toggleTheme = () =>
    setState({ ...stateRef.current, theme: stateRef.current.theme == "DARK" ? "LIGHT" : "DARK" });

  const functions = {
    download,
    onUploadCropped,
    onDeleteFile,
    onUnsplashDownload,
    onSelectFile,
    navigate,
    onUpload,
    toggleParent,
    onSelect,
    filter,
  };
  const api = { ...functions, ...stateRef.current };
  return <FileStorage {...api} />;
}

function mapStateToProps(state) {
  return {
    cms: state.cms,
    eventId: state.cms.eventId,
  };
}
export default connect(mapStateToProps)(FileStorageWrapper);
